import { Observable } from 'rxjs';
import { ContextService, Options, XenaClient } from 'src/app/services';
import { IPage, DeleteResult, IEntityDto, IListOptionsFilter } from 'src/app/xena-api';


export class BaseService<T extends IEntityDto, F extends IListOptionsFilter> {

  constructor(protected xenaClient: XenaClient, protected context: ContextService, private resourcePath: string) { }

  list(filter: F, options?: Options): Observable<IPage<T>> {
    const path = this.buildUrl();
    return this.xenaClient.list(path, filter, options);
  }

  save(entity: T, options?: Options): Observable<T> {
    if (entity.id == null) {
      return this.xenaClient.post<T, T>(this.buildUrl(), entity, options);
    }
      return this.xenaClient.put<T, T>(this.buildUrl(entity.id), entity, options);
  }

  get(id: number, options?: Options): Observable<T> {
    return this.xenaClient.get<T>(this.buildUrl(id), options);
  }

  delete(entity: T, options?: Options): Observable<DeleteResult> {
    return this.xenaClient.delete(this.buildUrl(entity.id), options);
  }

  protected buildUrl(id?: number): string {
    if (id == null) {
      return `/Fiscal/${this.context.fiscalId}/${this.resourcePath}`;
    } else {
      return `/Fiscal/${this.context.fiscalId}/${this.resourcePath}/${id}`;
    }
  }
}
